import { getRequest } from '../../../services/httpService';


export interface LocationParent {
  id: number;
  reference_id: string | null;
  level: number;
  name: string;
  color: string | null;
  specimen: string | null;
}

export interface LocationDetails {
  id: number;
  reference_id: string;
  plan: number;
  parents: LocationParent[];
  level: number;
  name: string;
  parent: number;
  occupancy: number;
  hierarchy: string;
  specimen: string;
  is_occupied: boolean;
  color: string | null;
}

export interface Cryo {
  id: number;
  cycle: number;
  cryo_date: string;
  locations: number;
  media_volume: string;
  semen_volume: string;
  expiry_date: string;
  remark: string;
  thaw_date: string | null;
  thaw_time: string | null;
  is_survived: boolean | null;
  plan: number | null;
  doctor: number | null;
  witness: number | null;
  reason: string | null;
  thaw_remark: string | null;
  recipient: number | null;
  status: string;
  cycle_number: string;
  patient_name: string;
  patient_mrn: string;
  cryo_preserved_by_name: string;
  sample_id: number;
  type_of_sperm: string | null;
  volume: number;
  sperm_concentration_million_per_ml: number;
  total_sperm_count: number;
  all_progressive: number | null;
  total_motility: number | null;
  immotile_percent: number | null;
  non_progressive_percent: number | null;
  material_count: number;
  patient_last_name: string;
  renewal_date: string | null;
  patient_id: number;
  location_details: LocationDetails;
  cycle_no: string;
  sample_no: string;
}

export interface SemenFreezing {
  cycle: number;
  sample_number: string;
  date: string;
  time: string;
  semen_collection_method: string;
  surgical_extraction_type: string;
  collection_date: string;
  collection_time: string;
  receiving_date: string;
  receiving_time: string;
  abstinence_period: string;
  viscosity: string;
  volume_ml: string;
  sperm_concentration_million_per_ml: string;
  remark: string;
  andrologist: number;
  status: string;
  cryo: Cryo[];
  andrologist_name:string,
  witnessed_by_name:string,
  prefreezing_save:boolean,
  semen_collection_method_label?:string,
  viscosity_label?:string,
}



export function getSemenFreezingReportUrl(Id: string): string {
  return `semen-freezing/cycle/${Id}/`; 
}
export function getSemenFreezingReport(Id: string): Promise<SemenFreezing[]> {
  return getRequest(getSemenFreezingReportUrl(Id), { responseType: 'json' });
}